import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=4e3b640c&scoped=true"
import script from "./foot.vue?vue&type=script&lang=js"
export * from "./foot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3b640c",
  null
  
)

export default component.exports